import { Component } from '@angular/core';

@Component({
  selector: 'app-hr',
  template: `<hr class="tw-my-4 -tw-mx-2 md:-tw-mx-4" />`,
})
export class HrComponent {}
